<div class="weather-page">

    <!-- Page Header -->
    <div class="weather-header">
        <div class="container">
            <h1 class="header-title">{{ 'weather_page.title' | translate }}</h1>
            <p class="header-subtitle">{{ 'weather_page.subtitle' | translate }}</p>

            <!-- City Selector -->
            <div class="city-filters">
                <button
                    *ngFor="let c of cities"
                    class="btn city-pill"
                    [class.active]="city === c.key"
                    (click)="setCity(c.key)"
                >
                    {{ c.flag }} {{ c.labelKey | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="container weather-content">

        <!-- Current Conditions -->
        <section class="mb-5">
            <h2 class="section-heading">🌡️ {{ 'weather_page.current_conditions' | translate: { city: (activeCity.labelKey | translate), country: (activeCity.countryKey | translate) } }}</h2>
            <div class="row g-4">
                <div class="col-sm-6">
                    <div class="weather-card weather-card-main">
                        <div class="d-flex align-items-center gap-4">
                            <div class="weather-icon-lg">{{ current.now.icon }}</div>
                            <div>
                                <div class="temp-lg">{{ current.now.temp }}°C</div>
                                <div class="condition-label">{{ current.now.conditionKey | translate }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="weather-card weather-card-metric text-center">
                        <div class="metric-value">{{ current.now.humidity }}%</div>
                        <div class="metric-label">💧 {{ 'weather_page.humidity' | translate }}</div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="weather-card weather-card-metric text-center">
                        <div class="metric-value">{{ current.now.wind }} km/h</div>
                        <div class="metric-label">💨 {{ 'weather_page.wind' | translate }}</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 7-Day Forecast -->
        <section class="mb-5">
            <h2 class="section-heading">📅 {{ 'weather_page.forecast_7day' | translate }}</h2>
            <div class="forecast-grid">
                <div class="forecast-card" *ngFor="let d of current.days">
                    <div class="forecast-day">{{ d.dayKey | translate }}</div>
                    <div class="forecast-icon">{{ d.icon }}</div>
                    <div class="forecast-condition">{{ d.conditionKey | translate }}</div>
                    <div class="forecast-temps">
                        <span class="forecast-high">{{ d.high }}°</span>
                        <span class="forecast-low">/ {{ d.low }}°</span>
                    </div>
                    <div class="forecast-rain" [ngClass]="{'rain-high': d.rain >= 60, 'rain-med': d.rain >= 30 && d.rain < 60, 'rain-low': d.rain < 30}">
                        💧 {{ d.rain }}%
                    </div>
                </div>
            </div>
        </section>

        <!-- Farming Advisories -->
        <section class="mb-5">
            <h2 class="section-heading">🌱 {{ 'weather_page.farming_advisories' | translate }}</h2>
            <div class="row g-4">
                <div class="col-md-4" *ngFor="let a of advisories">
                    <div class="advisory-card" [ngClass]="'advisory-' + a.tone">
                        <div class="advisory-icon">{{ a.icon }}</div>
                        <div class="advisory-title">{{ a.titleKey | translate }}</div>
                        <p class="advisory-text">{{ a.textKey | translate }}</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Seasonal Outlook -->
        <section class="mb-5">
            <h2 class="section-heading">🗓️ {{ 'weather_page.seasonal_outlook' | translate }}</h2>
            <div class="weather-card">
                <p class="outlook-text">
                    {{ 'weather_page.seasonal_outlook_text' | translate }}
                </p>
                <div class="row g-4 text-center">
                    <div class="col-md-4">
                        <div class="outlook-tile">
                            <div class="outlook-value">{{ 'weather_page.outlook_above_normal' | translate }}</div>
                            <div class="outlook-label">{{ 'weather_page.outlook_coastal_rainfall' | translate }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="outlook-tile">
                            <div class="outlook-value">{{ 'weather_page.outlook_near_normal' | translate }}</div>
                            <div class="outlook-label">{{ 'weather_page.outlook_sahelian_rainfall' | translate }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="outlook-tile">
                            <div class="outlook-value">+0.8°C</div>
                            <div class="outlook-label">{{ 'weather_page.outlook_temp_anomaly' | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</div>